// @flow
export { default } from './GrayBox';



// WEBPACK FOOTER //
// ./src/components/common/GrayBox/index.js